<template>
  <div class="video-shell">
    <div v-if="safeEmbedCode" class="youtube-embed" v-html="safeEmbedCode"></div>
    <div v-if="safeEmbedCode" class="youtube-share-blocker" aria-hidden="true"></div>
    <div v-else class="video-placeholder">
      <van-icon name="video-o" size="34" />
      <strong>No content yet</strong>
      <span>Stay tuned - live content will appear here</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { sanitizeYoutubeEmbedCode } from '@/utils/youtube-embed'

const props = defineProps<{ embedCode?: string | null }>()
const safeEmbedCode = computed(() => sanitizeYoutubeEmbedCode(props.embedCode))
</script>

<style scoped lang="scss">
.video-shell {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 56.25%;
  background: #171720;
  overflow: hidden;
}

.youtube-embed,
.video-placeholder {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.youtube-embed :deep(iframe) {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}

.youtube-share-blocker {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 20%;
  height: 30%;
  background: transparent;
}

.video-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;

  > * + * {
    margin-top: 12px;
  }

  strong {
    font-size: 30px;
    line-height: 1.2;
  }

  span {
    color: #b9b9c5;
    font-size: 22px;
  }
}
</style>
